// src/routes/RootRedirect.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { TOKEN_KEY, USER_ROLE_KEY } from '../../utils/constants';
import Hero from '../../components/common/Hero';

const RootRedirect: React.FC = () => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token) {
    return <Hero />;
  }

  const role = localStorage.getItem(USER_ROLE_KEY);

  if (role === 'ep') {
    return <Navigate to="/ep-dashboard" replace />;
  }

  if (role === 'admin') {
    return <Navigate to="/admin-dashboard" replace />;
  }

  if (role === 'parent') {
    return <Navigate to="/parent-dashboard" replace />;
  }

  return <Navigate to="/dashboard" replace />;
};

export default RootRedirect;
